// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A7jT","fullView":"styles_fullView__39JWf"};